import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { useDisclosureContext } from './DisclosureProvider.js';

var DisclosureRenderProp = function (_a) {
    var children = _a.children;
    return (jsx(Fragment, { children: children instanceof Function
            ? children(useDisclosureContext({ optional: true }))
            : children }));
};

export { DisclosureRenderProp };
//# sourceMappingURL=DisclosureRenderProp.js.map
